import { render, staticRenderFns } from "./salesmasterAction.vue?vue&type=template&id=2f5cbe2f&scoped=true"
import script from "./salesmasterAction.vue?vue&type=script&lang=js"
export * from "./salesmasterAction.vue?vue&type=script&lang=js"
import style0 from "./salesmasterAction.vue?vue&type=style&index=0&id=2f5cbe2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5cbe2f",
  null
  
)

export default component.exports